// extracted by mini-css-extract-plugin
export default {"wrapper":"OpeningBalanceSheets_wrapper__5ulHk"};